export const ReservationUrls = {
  Root: '/',
  /**
   * 予約
   */
  Reservation: '/patient/reservation',
  /**
   * 属性を持つ会員専用の予約
   */
  ReservationMemberstatus: '/patient/reservation/memberstatus',
  /**
   * 会員登録
   */
  Registration: '/patient/registration',
  /**
   * 予約完了
   */
  RegistrationComp: '/patient/registration/complete',
  /**
   * 会員未登録
   */
  NotRegistration: '/patient/notRegistration',
  /**
   * リダイレクト
   */
  RedirectManage: '/auth/redirect',
  /**
   * 診療メニュー選択不可
   */
  OutpatientFallback: '/outpatient/error',
  /**
   * マイページ
   */
  Mypage: '/patient/mypage',
  /**
   * トップ
   */
  Top: '/patient/top'
};
